module.exports = __webpack_public_path__ + "img/global-2012-france-roundtable.5e99b934.jpg";